(function () {
  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

  function openAR(button) {
    const glbUrl = button.getAttribute('data-glb-url');
    const usdzUrl = button.getAttribute('data-usdz-url');
    if (!glbUrl || glbUrl === 'https:') {
      console.error('AR badge missing data-glb-url');
      return;
    }

    const viewer = document.createElement('model-viewer');
    viewer.style.cssText = `
      position: fixed !important;
      top: 0 !important;
      left: 0 !important;
      right: 0 !important;
      bottom: 0 !important;
      width: 100vw !important;
      height: 100vh !important;
      height: 100dvh !important;
      z-index: 999999 !important;
      background: linear-gradient(#f5f5f5, #e0e0e0) !important;
      overflow: hidden !important;
    `;

    viewer.setAttribute('ar', '');
    viewer.setAttribute('ar-modes', 'scene-viewer webxr quick-look');
    viewer.setAttribute('camera-controls', '');
    viewer.setAttribute('auto-rotate', '');
    viewer.setAttribute('loading', 'eager');
    viewer.setAttribute('camera-orbit', '45deg 55deg 1.2m');
    viewer.setAttribute('min-camera-orbit', 'auto auto 1m');
    viewer.setAttribute('max-camera-orbit', 'auto auto 10m');
    viewer.setAttribute('field-of-view', '45deg');
    viewer.setAttribute('src', glbUrl);
    if (isIOS && usdzUrl && usdzUrl !== 'https:') {
      viewer.setAttribute('ios-src', usdzUrl);
    }

    document.body.appendChild(viewer);

    const closeButton = document.createElement('button');
    closeButton.innerHTML = '✕';
    closeButton.style.cssText = `
      position: absolute !important;
      top: 15px !important;
      right: 15px !important;
      background: rgba(0,0,0,0.8) !important;
      color: white !important;
      border: none !important;
      width: 44px !important;
      height: 44px !important;
      border-radius: 22px !important;
      font-size: 18px !important;
      cursor: pointer !important;
      z-index: 1000001 !important;
      display: flex !important;
      align-items: center !important;
      justify-content: center !important;
    `;
    closeButton.addEventListener('click', function () {
      if (viewer.parentNode) viewer.parentNode.removeChild(viewer);
    });
    viewer.appendChild(closeButton);

    const arButton = document.createElement('button');
    arButton.innerHTML = isIOS ? '📱 View in AR' : '🥽 View in Space';
    arButton.style.cssText = `
      position: absolute !important;
      bottom: ${isIOS ? '40px' : '80px'} !important;
      left: 50% !important;
      transform: translateX(-50%) !important;
      background: ${isIOS ? '#007AFF' : '#34A853'} !important;
      color: white !important;
      border: none !important;
      padding: 16px 24px !important;
      border-radius: 30px !important;
      font-weight: bold !important;
      font-size: 16px !important;
      cursor: pointer !important;
      z-index: 1000002 !important;
      box-shadow: 0 4px 16px rgba(0,0,0,0.3) !important;
      min-width: 200px !important;
      text-align: center !important;
      display: none !important;
      white-space: nowrap !important;
    `;
    arButton.addEventListener('click', function () {
      if (viewer.canActivateAR) {
        viewer.activateAR().catch(function (err) {
          console.error('AR activation failed:', err);
          alert('AR not available on this device');
        });
      } else {
        alert('AR not supported on this device');
      }
    });
    viewer.appendChild(arButton);

    const loadingDiv = document.createElement('div');
    loadingDiv.innerHTML = '⏳ Loading 3D Model...';
    loadingDiv.style.cssText = `
      position: absolute !important;
      top: 50% !important;
      left: 50% !important;
      transform: translate(-50%, -50%) !important;
      background: rgba(255,255,255,0.9) !important;
      padding: 20px !important;
      border-radius: 12px !important;
      font-size: 16px !important;
      z-index: 1000003 !important;
    `;
    viewer.appendChild(loadingDiv);

    viewer.addEventListener('load', function () {
      loadingDiv.style.display = 'none';
      setTimeout(function () {
        arButton.style.display = 'block';
      }, 1000);
    });

    viewer.addEventListener('error', function (event) {
      console.error('Model failed to load:', event);
      if (viewer.parentNode) viewer.parentNode.removeChild(viewer);
    });

    if (isIOS) {
      let attempts = 0;
      const maxAttempts = 50;
      const checkInterval = setInterval(function () {
        attempts++;
        if (viewer.canActivateAR) {
          arButton.style.display = 'block';
          clearInterval(checkInterval);
        } else if (attempts >= maxAttempts) {
          arButton.style.display = 'block';
          clearInterval(checkInterval);
        }
      }, 100);
      setTimeout(function () {
        if (arButton.style.display === 'none') {
          arButton.style.display = 'block';
        }
      }, 3000);
    }
  }

  document.addEventListener('click', function (e) {
    const button = e.target.closest('.ar-card-button, .ar-icon-badge');
    if (!button) return;
    e.preventDefault();
    e.stopPropagation();
    openAR(button);
  }, true);
})();
